import { render, staticRenderFns } from "./SsoCfgIndex.vue?vue&type=template&id=0e9ff088&scoped=true"
import script from "./SsoCfgIndex.vue?vue&type=script&lang=js"
export * from "./SsoCfgIndex.vue?vue&type=script&lang=js"
import style0 from "./SsoCfgIndex.vue?vue&type=style&index=0&id=0e9ff088&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ff088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9ff088')) {
      api.createRecord('0e9ff088', component.options)
    } else {
      api.reload('0e9ff088', component.options)
    }
    module.hot.accept("./SsoCfgIndex.vue?vue&type=template&id=0e9ff088&scoped=true", function () {
      api.rerender('0e9ff088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/SsoCfgIndex.vue"
export default component.exports